import { render, staticRenderFns } from "./PatientVisitReport.vue?vue&type=template&id=fb8c1524&scoped=true"
import script from "./PatientVisitReport.vue?vue&type=script&lang=js"
export * from "./PatientVisitReport.vue?vue&type=script&lang=js"
import style0 from "./PatientVisitReport.vue?vue&type=style&index=0&id=fb8c1524&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8c1524",
  null
  
)

export default component.exports